module.exports = new __parcel__URL__("E2.62f52997.mp3").toString();